import styled from 'styled-components'

import { Text } from '../text'

import { Color } from '../../theme/color'
import type { ColorKeys } from '../../theme/color'

interface NoticeContainerProps {
  title?: string
  list?: any[]
  $backgroundColor?: ColorKeys
}

export function NoticeContainer({ title, list, $backgroundColor }: NoticeContainerProps) {
  return (
    <Container $backgroundColor={$backgroundColor}>
      {title && (
        <Text size={14} weight={600}>
          {title}
        </Text>
      )}
      {list && (
        <ul>
          {list.map((notice, index) => {
            if (typeof notice === 'string') {
              return (
                <li key={index}>
                  <Text size={14} lineHeight={22} color="text_secondary">
                    • {notice}
                  </Text>
                </li>
              )
            }
            return <li key={index}>• {notice}</li>
          })}
        </ul>
      )}
    </Container>
  )
}

const Container = styled.div<Pick<NoticeContainerProps, '$backgroundColor'>>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  ${({ $backgroundColor }) => ($backgroundColor ? `background-color: ${Color[$backgroundColor]};` : '')}
  li {
    list-style: none;
  }
`
